<template>
    <div id="app">
        <transition name="fade"
                    mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'app',
        components: {}
    }

</script>

<!--<style src="./css/_index.scss" lang="scss"></style>-->
<style src="./css/_commen.scss" lang="scss"></style>
<style src="./css/_reset.scss" lang="scss"></style>




// WEBPACK FOOTER //
// App.vue?629ccd44